module.exports = __webpack_public_path__ + "media/images/pc/specials/common/special_c_29-3107a895061c19c8f34f8f0f7588d000.jpg";